// extracted by mini-css-extract-plugin
export default {"root":"ISnr3N","loading":"TOQp80","preloader":"cfs6BR","semi-rotate":"_2z1jt","semiRotate":"_2z1jt","inner-rotate":"PHCa9j","innerRotate":"PHCa9j"};